import React from 'react';
import {Field, reduxForm} from 'redux-form';
import PropTypes from 'prop-types';
import { modal } from "react-redux-modal";
import {connect} from 'react-redux';
import validate from './validate';
import { UploadAvatarModal } from '../../';
import { renderField, renderCheckbox, renderHidden } from '../../../utils/renderFields';
import { postSignup } from '../../../actions/auth';
import './styles.scss';
import { saveUserAvatar } from '../../../actions/currentUser';

const propTypes = {
  errors: PropTypes.array,
  socialData: PropTypes.object,
  removeModal: PropTypes.func,
  countries: PropTypes.array,
};

const defaultProps = {
  errors: [],
  socialData: null,
  initialValues: {},
};

class ConfirmInfoForm extends React.Component {

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.successfulSubmit = this.successfulSubmit.bind(this);
  }

  successfulSubmit() {
    this.props.removeModal();
    modal.add(UploadAvatarModal, {
      title: '',
      size: 'medium',
      hideTitleBar: true,
      registrationSuccess: true,
      afterAcceptCallback: (avatar) => this.props.dispatch(saveUserAvatar(avatar)),
    });
  }

  submit(values) {
    values.social = true;
    return this.props.dispatch(postSignup(values, this.successfulSubmit));
  }

  render() {
    const { handleSubmit, errors, error, reset, pristine, submitting, statusText, countries } = this.props;
    const { email, username, display_name, first_name, last_name, avatar_uri } = this.props.initialValues;

    const termsHTML = (<span>I agree to the <a href="/extra/terms_of_use/" className="parent-link">Terms of Use</a>, <a
      href="/extra/privacy_policy/" className="parent-link">Privacy Policy</a>, and <a
      href="/extra/community_guidelines/" className="parent-link">Community Guidelines</a></span>);

    return (
      <form className="pb-20 confirm-info-form" onSubmit={handleSubmit(this.submit)}>
        <div className="row no-gutters">
          <div className="col-sm-6">
            { avatar_uri &&
              <div className="avatar" style={{backgroundImage: `url("${avatar_uri}")`}} />
            }
          </div>
          <div className="col-sm-6">
            <span className={error ? 'has-danger' : ''}>
              <span className="u-fontSize-11 form-control-feedback">{error}</span>
            </span>
            <Field name="first_name" className="form-control" type="input" component={renderField} value={first_name}
                   label="First Name"  />
            <Field name="last_name" className="form-control" type="input" component={renderField} value={last_name}
                   label="Last Name"  />
          </div>
        </div>
        <div className="row no-gutters">
          <div className="col-sm-6 right-space">
          <Field name="username" className="form-control" type="input" component={renderField} value={username}
                 label="Username"  />
          </div>
          <div className="col-sm-6">
            <Field name="email" type="email" component={renderField} groupClass="row" className="form-control"
                   value={email} label="Email" />
          </div>
        </div>
        <div className="row no-gutters">
          <div className="col-sm-6">
            <Field name="newsletter" component={renderCheckbox} className="form-check-input" labelClassName="opt-in-label"
                   label="Sign me up for the newsletter"/>
            <Field name="terms" type="checkbox" component={renderCheckbox} className="form-check-input" labelClassName="terms-label" labelHTML={termsHTML}/>
            <button type="submit" disabled={submitting} className="btn btn-primary">Confirm</button>
          </div>
          <Field name="provider_name" component={renderHidden} />
          <Field name="provider_id" component={renderHidden} />
          <Field name="avatar_uri" component={renderHidden} />
        </div>
      </form>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  let initialValues = state.auth.janrain;
  if(initialValues) {
    Object.keys(initialValues).map((key) => {
      if (initialValues[key] === 'None')
        initialValues[key] = '';
    });
  } else {
    initialValues = {
      email: '',
      username: '',
      display_name: '',
      first_name: '',
      last_name: '',
      avatar_uri: '',
      provider_name: '',
      provider_id: '',
    };
  }
  initialValues = Object.assign({}, initialValues, {
    newsletter: true,
  })
  return {
    initialValues: initialValues,
    removeModal: ownProps.removeModal,
  }
};

ConfirmInfoForm = reduxForm({
  form: 'confirm-info',
  validate,
  fields: ['username', 'country', 'email'],
})(ConfirmInfoForm);

ConfirmInfoForm.propTypes = propTypes;
ConfirmInfoForm.defaultProps = defaultProps;

export default connect(mapStateToProps)(ConfirmInfoForm);
